import React from 'react';
import PropTypes from 'prop-types';
import gifTipeeeImage from 'assets/images/TipeeeTutorial/gif_Tipeee_step_1.gif';
import { TutorialImage } from 'styles/TutorialImages';
import Text from 'components/Text';
import Link from 'components/Link';

import StepContent from '../../../components/StepContent';

const Step4 = ({ processStep, goPrev }) => (
  <StepContent provider="tipeee" processStep={processStep} goPrev={goPrev}>
    <Text lineHeight={1.58} align="center" mb={20}>
      Jeśli nie posiadasz konta, musisz rozpocząć od rejestracji w serwisie. Wejdź na:
    </Text>
    <Text align="center" mb={30}>
      <Link href="https://www.tipeeestream.com/login" target="_blank">
        https://www.tipeeestream.com/login
      </Link>
    </Text>
    <Text lineHeight={1.58} align="center" mb={20}>
      Rozpocznij proces rejestracji wybierając dowolne socialmedia dzięki któremu będziesz logował
      się do serwisu Tipeee.
    </Text>
    <TutorialImage style={{ marginBottom: 32 }} src={gifTipeeeImage} />
  </StepContent>
);

export default Step4;

Step4.propTypes = {
  processStep: PropTypes.instanceOf(Function).isRequired,
  goPrev: PropTypes.instanceOf(Function).isRequired,
};
